import {
  IActionContextAPI,
  NativeActionsList,
  ActionName,
} from '@wix/editor-platform-host-integration-apis';
import { Action, DashboardAction } from '@wix/component-protocol/schema';
import { PlatformContext } from './types';

export class ActionContextAPI implements IActionContextAPI {
  #action: Action | DashboardAction;
  #actionName: string;
  #context: PlatformContext;
  #overrides: Partial<IActionContextAPI>;

  constructor(
    action: Action | DashboardAction,
    actionName: string,
    context: PlatformContext,
    overrides: Partial<IActionContextAPI> = {},
  ) {
    this.#action = action;
    this.#actionName = actionName;
    this.#context = context;
    this.#overrides = overrides;
  }

  getAutoInjectedEditorPointers() {
    return this.#context.componentsAPI.containers.getAutoInjectedEditorPointers(
      this.#context.editorPointers,
    );
  }

  getData() {
    // Only native actions support getActionDataItems
    if (!Object.values(NativeActionsList).includes(this.#actionName as any)) {
      return [];
    }
    return this.#context.componentsAPI.editActions.getActionDataItems(
      this.#actionName as keyof typeof NativeActionsList,
      this.#context.editorPointers,
    );
  }

  getStyle() {
    return this.#context.componentsAPI.components.getStyle(
      this.#context.editorPointers,
    );
  }

  getActionDefinition(): Action | DashboardAction {
    return this.#action;
  }

  getOrigin() {
    return this.#context.actionMetadata?.origin;
  }

  getDisplayName() {
    return this.#context.componentsAPI.components.getDisplayName(
      this.#context.editorPointers[0],
    );
  }

  getActionableElements() {
    return (
      this.#overrides.getActionableElements?.() ??
      this.#context.componentsAPI.actionableElements.getActionableElements(
        this.#context.editorPointers,
        this.#actionName as ActionName,
      )
    );
  }
}
